export const iconFontAwesomeMoneyFileInvoiceDollar = (
	<i className="fa-solid fa-file-invoice-dollar"></i>
);
